//#region src/coupon_provider.ts
var CouponProvider = /* @__PURE__ */ function(CouponProvider) {
	CouponProvider["None"] = "none";
	CouponProvider["Pos"] = "pos";
	CouponProvider["Loyalty"] = "loyalty";
	CouponProvider["Bite"] = "bite";
	return CouponProvider;
}(CouponProvider || {});
//#endregion
export { CouponProvider };

//# sourceMappingURL=coupon_provider.js.map